import React from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

const KPIWidget = ({
  title,
  value,
  change,
  changeType,
  icon,
  description,
  color = 'primary',
  loading
}) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    error: 'bg-error/10 text-error',
    accent: 'bg-accent/10 text-accent'
  };

  if (loading) {
    return (
      <div className="bg-card rounded-lg border border-border p-6">
        <div className="animate-pulse">
          <div className="h-12 w-12 bg-muted rounded-lg mb-4"></div>
          <div className="h-4 bg-muted rounded w-2/3 mb-2"></div>
          <div className="h-8 bg-muted rounded w-1/2 mb-2"></div>
          <div className="h-3 bg-muted rounded w-full"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-6 hover:shadow-lg transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className={cn(
          'w-12 h-12 rounded-lg flex items-center justify-center',
          colorClasses?.[color]
        )}>
          <Icon name={icon} size={24} />
        </div>
        <div className={cn(
          'px-2 py-1 rounded-full text-xs font-medium',
          changeType === 'positive' ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
        )}>
          {change}
        </div>
      </div>
      
      <div className="space-y-1">
        <h3 className="text-sm font-medium text-muted-foreground">
          {title}
        </h3>
        <div className="text-3xl font-bold text-foreground">
          {value}
        </div>
        <p className="text-xs text-muted-foreground">
          {description}
        </p>
      </div>
    </div>
  );
};

export default KPIWidget;